import React from 'react'
import Container from '../container/Container'
import Header from 'components/header/pageHeader/Header'
import { Main } from './GameRulesStyled'
import { gameRulesProps } from './interfaces'

export default function GameRules({
  children,
  colors,
  handleAbove,
  audio,
}: gameRulesProps) {
  return (
    <Container
      textColor={colors.primary}
      backgroundColor={colors.secondaryBackground}
      unBlur={false}
    >
      <Header
        name='game rules'
        strokeColor={colors.secondaryBackground}
        background={colors.primary}
        borderColor={colors.primary}
        handleAbove={handleAbove}
        audio={audio}
      />
      <Main>{children}</Main>
    </Container>
  )
}
